export const msalConfig = {
  auth: {
    // clientId: "0022e0d1-d6fc-49ef-98bd-f11668440b94", // From Azure
    // authority: "https://login.microsoftonline.com/34120a19-2a32-48c7-834a-87218704e048", // or tenant-specific
    // redirectUri: "http://localhost:3000",
    // postLogoutRedirectUri: "/",
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTHORITY || '',
    redirectUri: process.env.REACT_APP_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_LOGOUT_REDIRECT_URI || '/',
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
    secureCookies: true,
  },
  system: {
    loadFrameTimeout: 100000,
    asyncPopups: false,
    navigateFrameWait: 500,
    allowRedirectInIframe: true,
  },
};



export const loginRequest = {
  scopes: ["openid", "profile", "offline_access", "User.Read","Group.Read.All"],
};
